import { render, staticRenderFns } from "./IngredientsOrder.vue?vue&type=template&id=213e5347&"
import script from "./IngredientsOrder.vue?vue&type=script&lang=js&"
export * from "./IngredientsOrder.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports